import React, { Fragment, useContext, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Footer } from '../../Component/Footer/Footer';
import { Header } from '../../Component/Header/Header';
import { styleContextApp } from '../StyleContext';
import { ThanksButton } from '../Thanks/ThankStyle';
import header from './headerPic.png';
import { PrivacyContent, PrivacyText, PrivacyTitle, PrivacyWrapper } from './PrivacyStyle';

export const Privacy = () => {
    const styleType = useContext(styleContextApp);
    useEffect(() => {
        window.scrollTo(0,0);
    }, []);

    return(
        <PrivacyWrapper>
            <Header 
                title={'隱私政策'}
                styleType={styleType} 
                hasMarginTop={false} 
                mobileHeight={404}
                headerHeight={593}
                pictures={[header]}
            />
            <PrivacyText styleType={styleType} >
                <PrivacyTitle styleType={styleType}>
                    隱私政策
                </PrivacyTitle>
                <PrivacyContent styleType={styleType}>

                meguru-travel.com由YOK株式會社旗下品牌日本巡旅擁有並經營管理（以下簡稱“日本巡旅”）。在使用通過meguru-travel.com (“站點”)提供的日本巡旅服務時，我們會請求您提供相關的個人信息（“個人資料”），以下具體隱私保護政策將會解釋我們怎樣收集、使用、披露，或以其它形式運用個人身份信息。當您訪問我們的網站，您需要同意隱私保證政策中具體解釋的收集、使用、公佈和以其它形式運用您的個人信息的政策。
                <p></p>
根據法律的變更，個人信息收集和使用政策的更改，網站內容的變化，或技術的更新，日本巡旅有時會對本隱私政策進修改。如果我們做出的修改改變了收集或使用個人資料的方式，所有變更將會發佈在本隱私政策頁面上，同時政策生效日期會被標明於隱私政策頁面的最上方。因此，您應該定期閱覽隱私政策，以了解我們最新的政策和做法。日本巡旅也會在實施新的政策前明確標註變更之內容。
<p></p>
<b>我們收集哪些信息</b>
<p></p>
我們收集您在使用網站時，需要向我們提供的個人信息。個人信息可能包括您的姓名、地址、聯繫電話、信用卡信息或電子郵件地址。我們還可能會收集一些非個人身份識別信息，而這些信息有可能會聯繫到您的個人信息，包括您的登陸名，IP地址和密碼，以及某些特定搜索的相關信息。
<p></p>
<b>個人信息安全性</b>
<p></p>
日本巡旅十分重視您的個人信息安全，為防止未經授權的訪問，我公司承諾實施適當、具體、電子、標準管理的措施保障及保護個人信息不受到意外或非法的毀壞、意外丟失、篡改、以及未經授權的披露或非法使用。為確保信用卡在線交易的使用安全，meguru-travel.com使用SSL(Secure Sockets Layer)技術在交易過程中加密信用卡信息。
<p></p>
<b>我們如何使用收集的信息</b>
<p></p>
我們使用收集到的個人信息和其它資料，用於註冊您在網站上使用我們的服務、享受日本巡旅回饋項目、確保為您提供所要求的產品和服務、提供更多高效便捷的功能讓您更輕鬆地使用我們的網站，以及任何有關的服務。我們也在以下情況使用您的個人信息，提出快速預訂申請、提供更好的客戶支持、新服務即時通知及享受特別優惠。有時，日本巡旅可能會通過電子郵件與您聯絡，以了解您在使用網站時的反饋和意見，進一步協助我們提高改善網站質量和服務；或者我們會在您已同意接受此類電子郵件的情況下，向您發送特惠折扣價或特別優惠的信息。如果您不願意接收特惠折扣價或特別優惠的信息通知，只需通過點擊在已收到信息通知郵件中的鏈接，回復告知我們即可。
<p></p>
<b>與何人共享您的信息</b>
<p></p>
日本巡旅會按照個案具體情況，和我們授權提供服務的第三方共享您的個人信息，例如網站託管服務、信息分析等，個人信息共享之目的為在市場上提供產品和服務、處理信用卡交易和以其它方式提供客戶服務。我們要求第三方嚴格遵守此政策，有義務維護個人信息的安全和保密，並只能按照我們的指示使用個人信息，嚴禁第三方將您的個人信息用於任何其它目的。
<p></p>
在某些情況下，日本巡旅可能直接與第三方進行交易以確保提供所要求的服務，我們可能也會在當您使用網站預訂旅舍客房或獲取其它產品或服務時，向旅舍或其他相關第三方提供您的個人信息。
<p></p>
日本巡旅可能會在以下情況下透露個人信息，其中包括：保護自己免受法律責任、回應傳票、司法程序、配合執法官員合法要求、在其它要求下配合法律需要、或買家以任何方式出售、轉讓或交易我們全部或部分經營的業務或公司。根據我們的產品和服務適用條款，我們也可能會公開個人信息以強制執行或應用於我們的政策和條款，或用於保護日本巡旅的權利、財產或安全，以及我們的用戶和其他相關人士。
<p></p>
以上所述之政策，個人信息接收方可能因位於不同國家的管轄權限內，而不能提供與您所在國法律範圍內同等程度的信息保護。
<p></p>
<b>Cookies的使用政策</b>
<p></p>
為了向您提供更高效和更高質的服務，我們在網站是使用“cookie”技術。 Cookies是存儲在用戶電腦硬盤上的少量數據，可以幫助網站通過記憶用戶訪問網頁的信息，“個性化”網頁或記住您。 Cookies可以存儲大量的信息，包括IP地址、導航信息、服務器信息、數據傳輸時間、用戶自定義，以及使用網站時需要的電子郵件地址和密碼。大部分網絡瀏覽器工具欄選項中的“幫助”項，都會告訴您如何防止瀏覽器接收新的cookie，或怎樣配置瀏覽器拒絕cookie信息。如果您關閉cookie，您可能無法使用網站的重要功能或瀏覽某些內容，您在使用本網站時將會受到限制。
<p></p>
<b>如何訪問或修改個人身份信息</b>
<p></p>
如果您想要更新之前所提供的任何個人信息，或使用、整改、刪除信息，或使用必須符合法律規定的個人信息，請與我們聯絡 info@yok-travel.com。為保障您的隱私和安全，我們將先要驗證您的身份，才能訪問或更改個人信息。任何關於訪問個人信息的疑問，我們會在30天內予以答复。
<p></p>
<b>關於兒童的特別提示</b>
<p></p>
未滿18歲的未成年兒童不能使用我們網站的任何服務。

                </PrivacyContent>

                <Link to='/'>
            <ThanksButton styleType={styleType} mt={64} mab={56} mmt={24} mmab={28}>
                <span>返回首页</span>
            </ThanksButton>
            </Link>

            </PrivacyText>
            <Footer styleType={styleType}></Footer>
        </PrivacyWrapper>

    )
}